export const VISUAL_COLORS = Object.freeze({
  emerald: '#12bd92',
  emeraldBright: '#35d1aa',
  emeraldSoft: '#79e2c5',
  silver: '#e0e2df',
  secondary: '#a1a9a9',
  muted: '#697477',
  teal: '#4f9f9d',
  blue: '#4b7d91',
  amber: '#d6a24e',
  red: '#d2635c',
  violet: '#8f7aa8',
})

export const DATA_SERIES_COLORS = Object.freeze([
  VISUAL_COLORS.emerald,
  VISUAL_COLORS.emeraldSoft,
  VISUAL_COLORS.teal,
  VISUAL_COLORS.blue,
  VISUAL_COLORS.amber,
  VISUAL_COLORS.red,
  VISUAL_COLORS.muted,
  VISUAL_COLORS.violet,
])

export const STATUS_SERIES_COLORS = Object.freeze([
  VISUAL_COLORS.emerald,
  VISUAL_COLORS.amber,
  VISUAL_COLORS.red,
])

export const CHART_THEME = Object.freeze({
  linePrimary: VISUAL_COLORS.emerald,
  linePrimaryFill: 'rgba(18, 189, 146, 0.12)',
  lineSecondary: VISUAL_COLORS.teal,
  lineSecondaryFill: 'rgba(79, 159, 157, 0.09)',
  textDark: '#c3cac9',
  mutedDark: '#879395',
  gridDark: 'rgba(224, 226, 223, 0.10)',
  textLight: '#243431',
  mutedLight: '#61706d',
  gridLight: 'rgba(18, 52, 45, 0.12)',
})
